module.exports = __webpack_public_path__ + "img/bank_icon13.b242a7d3.png";